import {
  Audio,
  Eye,
  Mindfulness,
  Question,
  Timer,
  Trophy,
  Video,
  Pencil,
  Cloud,
  Wave,
  NavTalk,
} from 'icons';

// SEGMENTS
export const SeriesSegmentIcons: {
  [key: string]: React.ComponentType<{
    primaryColor: string;
    secondaryColor: string;
    height?: number;
    width?: number;
  }>;
} = {
  'chat-square': NavTalk,
  eye: Eye,
  headphones: Audio,
  journal: Pencil,
  mindfulness: Mindfulness,
  questions: Question,
  reflection: Cloud,
  smile: Wave,
  pencil: Pencil,
  thinking: Cloud,
  timer: Timer,
  trophy: Trophy,
  video: Video,
};
